 <!-- Commented Out To Prepare for release, uncomment this div to renable QA Tools
<div>
	<h5 class="px-3 mt-2">TEMPORARY QA TOOLS</h5>
	<nav>
		<div class="row px-3">
			<div class="col-6">
				<h6>Main flow</h6>
				<ul>
					<li>
						<a
							routerLink="/marketing"
							routerLinkActive="active"
							ariaCurrentWhenActive="page"
							>OB01: Marketing</a
						>
					</li>
					<li>
						<a
							routerLink="/emailotp"
							routerLinkActive="active"
							ariaCurrentWhenActive="page"
							>OB02: Email OTP</a
						>
					</li> -->
					<!-- <li>
						<a
							routerLink="/business-description"
							routerLinkActive="active"
							ariaCurrentWhenActive="page"
							>OB03: Business Description</a
						>
					</li> -->
					<!-- <li>
						<a
							routerLink="/business-type"
							routerLinkActive="active"
							ariaCurrentWhenActive="page"
							>OB04: Business Type</a
						>
					</li>
					<li>
						<a
							routerLink="/business-activity"
							routerLinkActive="active"
							ariaCurrentWhenActive="page"
							>OB05a: Business Activity</a
						>
					</li>
					<li>
						<a
							routerLink="/fatca"
							routerLinkActive="active"
							ariaCurrentWhenActive="page"
							>OB05b: FATCA</a
						>
					</li>
					<li>
						<a
							routerLink="/income-details"
							routerLinkActive="active"
							ariaCurrentWhenActive="page"
							>OB06: Income Details</a
						>
					</li>
					<li>
						<a
							routerLink="/tax-details"
							routerLinkActive="active"
							ariaCurrentWhenActive="page"
							>OB07: Tax Details</a
						>
					</li>
					<li>
						<a
							routerLink="/contact-ownership"
							routerLinkActive="active"
							ariaCurrentWhenActive="page"
							>OB08: Contact Ownership</a
						>
					</li>
					<li>
						<a
							routerLink="/contact-details"
							routerLinkActive="active"
							ariaCurrentWhenActive="page"
							>OB09: Contact Details (KYC)</a
						>
					</li>
					<li>
						<a
							routerLink="/ownership-structure"
							routerLinkActive="active"
							ariaCurrentWhenActive="page"
							>OB10a: Ownership Structure</a
						>
					</li>
					<li>
						<a
							routerLink="/add-edit-shareholder-director"
							routerLinkActive="active"
							ariaCurrentWhenActive="page"
							>OB10b: Add-Edit-Shareholder-Director</a
						>
					</li>
					<li>
						<a
							routerLink="/review"
							routerLinkActive="active"
							ariaCurrentWhenActive="page"
							>OB11: Review</a
						>
					</li>
					<li>
						<a
							routerLink="/complete"
							routerLinkActive="active"
							ariaCurrentWhenActive="page"
							>OB12: Complete (Generic Gated)</a
						>
					</li>
					<li>
						<a
							routerLink="/verification-gated"
							routerLinkActive="active"
							ariaCurrentWhenActive="page"
							>OB12b: Verification Gated</a
						>
					</li>
				</ul>
			</div>
			<div class="col-6">
				<h6>Error screens</h6>
				<ul>
					<li>
						<a
							routerLink="/generic-error"
							routerLinkActive="active"
							ariaCurrentWhenActive="page"
							[state]="{ canNavigate: true }"
							>Generic Error</a
						>
					</li>
					<li>
						<a
							routerLink="/quebec-restriction"
							routerLinkActive="active"
							ariaCurrentWhenActive="page"
							[state]="{ canNavigate: true }"
							>Quebec Restriction Error</a
						>
					</li>
					<li>
						<a
							routerLink="/age-restriction-director"
							routerLinkActive="active"
							ariaCurrentWhenActive="page"
							[state]="{ canNavigate: true, restrictionType: 'DIRECTOR' }"
							>Age of Majority Restriction (Director)</a
						>
					</li>
					<li>
						<a
							routerLink="/age-restriction-banking"
							routerLinkActive="active"
							ariaCurrentWhenActive="page"
							[state]="{ canNavigate: true, restrictionType: 'BANKING' }"
							>Age of Majority Restriction (Banking)</a
						>
					</li>
					<li>
						<a
							routerLink="/max-accounts-error"
							routerLinkActive="active"
							ariaCurrentWhenActive="page"
							[state]="{ canNavigate: true }"
							>Max SBB Acounts Error</a
						>
					</li>
					<li>
						<a
							routerLink="/ownership-restriction"
							routerLinkActive="active"
							ariaCurrentWhenActive="page"
							[state]="{ canNavigate: true }"
							>Ownership Restriction Error</a
						>
					</li>
					<li>
						<a
							routerLink="/something-went-wrong"
							routerLinkActive="active"
							ariaCurrentWhenActive="page"
							[state]="{ canNavigate: true }"
							>Something Went Wrong Error</a
						>
					</li>
					<li>
						<a
							routerLink="/technical-difficulties"
							routerLinkActive="active"
							ariaCurrentWhenActive="page"
							[state]="{ canNavigate: true }"
							>Technical Difficulties Error</a
						>
					</li>
					<li>
						<a
							routerLink="/loading-customer"
							routerLinkActive="active"
							ariaCurrentWhenActive="page"
							>Loading Customer</a
						>
					</li>
				</ul>
			</div>
		</div>
	</nav>
	<hr class="my-0" />
</div> -->
<div class="app-root d-flex flex-column">
	<app-header *ngIf="!hideHeader()"></app-header>
	<main class="flex-grow-1 flex-shrink-0">
		<router-outlet></router-outlet>
		<app-footer *ngIf="!hideFooter()"></app-footer>
	</main>
</div>
